export default {
  title: '山西省安装集团股份有限公司-投资者关系',
  home: {
    nav1: '投资者关系',
    nav2: '信息披露',
    nav3: '企业管治',
    nav4: '股票信息',
    nav5: '投资者联络'
  },
  item1: {
    tit: '欢迎来到山西省安装集团股份有限公司投资者关系',
    txt: '我们是一家总部位于中国山西省太原市的工程服务商。我们从事专业工业工程、专业配套工程、其他工程及非工程业务。根据弗若斯特沙利文的资料，按2022年的收入计，我们在超过500名山西省专业工业工程承包商中排名第一，并在中国超过10000名专业工业工程合同承包公司中位列第五。',
    txt1: '山西省专业工业工程承包商2022年收入',
    txt2: '中国专业工业工程合同承包公司2022年收入'
  },
  item2: {
    tit1: '招股文件',
    tit2: '公告通函',
    tit3: '业绩报告',
    strDate: '开始日期',
    endDate: '结束日期',
    input: '请输入关键词',
    all: '总计',
    txt: '条数据'
  },
  item3: {
    tit1: '概览',
    tit2: '治理文件',
    tit3: '管理团队'
  },
  item4: {
    tit1: '地址',
    tit2: '电话/传真',
    tit3: '邮编',
    txt: '中国山西省山西转型综合改革示范区唐槐产业园新化路8号'
  },
  item5: {
    tit1: '分时K线',
    tit2: '日K线图',
    tit3: '周K线图',
    tit4: '月K线图'
  }
}
